import axios from "axios"
import { useEffect,useState } from "react"
import AddCliente from "./AddCliente"
import EditCliente from "./EditCliente"
import DelCliente from "./DelCliente"
export default function Clientes({usuario}){
    const columnas=["Nombre","Estado"]
    const [clientes,setClientes]=useState([])
    const [accion,setAccion]=useState("")
    const [abiertos,setAbiertos]=useState(true)
    const [cerrados,setCerrados]=useState(true)
    useEffect(()=>{
        axios.get("https://www.asinova.es/webapi/api/Clientes/abierto-cerrado")
            .then(res=>setClientes(res.data.sort((x,y)=>x.nombre.localeCompare(y.nombre))))
    },[])
    return(
        <>
            <h1 style={{textAlign:'center',margin:'1rem'}}>CLIENTES</h1>
            {usuario.administrador?
            <div className="div-opciones">
                <a className="btn-form" onClick={()=>setAccion(accion=="post"?"":"post")}>Añadir</a>
                <a className="btn-form" onClick={()=>setAccion(accion=="put"?"":"put")}>Editar</a>
                <a className="btn-form" onClick={()=>setAccion(accion=="delete"?"":"delete")}>Eliminar</a>
            </div>
            :null}
            <div className='flex' style={{justifyContent:'center',width:'fit-content',margin:'0 auto'}}>
                <div style={{margin:'0.5rem 1rem',width:'fit-content',marginTop:'0'}}>
                    <input type="checkbox" id={"abiertos"} name={"abiertos"} style={{margin:'0'}} checked={abiertos} onChange={()=>{setAbiertos(!abiertos)}}/>
                    <label for={"abiertos"} style={{margin:'0 0.5rem'}}>Abiertos</label>
                </div>
                <div style={{margin:'0.5rem 1rem',width:'fit-content',marginTop:'0'}}>
                    <input type="checkbox" id={"cerrados"} name={"cerrados"} style={{margin:'0'}} checked={cerrados} onChange={()=>{setCerrados(!cerrados)}}/>
                    <label for={"cerrados"} style={{margin:'0 0.5rem'}}>Cerrados</label>
                </div>
            </div>
            <table style={{margin:'0rem auto 1rem auto',borderRadius:'5px'}}>
                <tr>
                    {columnas.map((col,index)=>(
                        <th key={index}>{col}</th>
                    ))}
                </tr>
                {clientes.filter(x=>(x.abierto && abiertos) || (!x.abierto && cerrados)).map(x=>(
                    <tr className={x.abierto?"":"cerrado"}><td>{x.nombre}</td><td>{x.abierto?"Abierto":"Cerrado"}</td></tr>
                ))}
            </table>
            {accion!="" ?
                <div className="ventana-emergente">
                    <a className="btn-form" onClick={()=>setAccion("")} style={{padding:'0.1rem 0.45rem',marginTop:'1rem',float:'right'}}>X</a>
                    {accion=="post"?
                    <AddCliente setClientes={setClientes}/>:
                    accion=="put"?
                    <EditCliente clientes={clientes} setClientes={setClientes}/>:
                    <DelCliente clientes={clientes} setClientes={setClientes}/>
                    }
                </div>
            :null}
        </>
    )
}